module.exports = __webpack_public_path__ + "img/clean1.c94511ee.png";